import colors from "../base/colors";
import borders from "../base/borders";
import boxShadows from "../base/boxShadows";

const { background } = colors;
const { borderRadius } = borders;

const paper = {
  styleOverrides: {
    root: {
      backgroundColor: background.paper,
      backgroundImage: "none",
      borderRadius: borderRadius.lg,
      border: `1px solid ${background.cardBorder}`,
      boxShadow: boxShadows.xs,
    },

    elevation0: {
      boxShadow: "none",
      border: `1px solid ${background.cardBorder}`,
    },

    elevation1: {
      boxShadow: boxShadows.xs,
    },

    elevation2: {
      boxShadow: boxShadows.sm,
    },
  },
};

export default paper;
